import useTranslation from 'next-translate/useTranslation'

const StatusMessage = function ({
  asset,
  operation,
  showAssetMessage,
  showMessage,
  showStatusMessage
}) {
  const { t } = useTranslation()
  return showMessage ? (
    <div className="bg-red-02 mb-6 px-6 py-3 text-center text-sm text-gray-300 first-letter:capitalize md:mx-7">
      {showStatusMessage
        ? t('status-message', { operation: t(operation) })
        : showAssetMessage
        ? t('status-message-asset', {
            operation: t(operation),
            symbol: asset.symbol
          })
        : null}
    </div>
  ) : null
}

export default StatusMessage
